import React from 'react';
import _ from 'underscore';
import { Tabs } from 'antd';

const { TabPane } = Tabs;




const Invoices = () => {



  return (
    JSON.parse(localStorage.getItem('customerData')).id == 269 ?
    <div>
<p style={{fontSize:18,fontWeight:700,padding:20}}>
      <i className="icofont-exclamation-tringle" style={{color:'red',fontSize:20}}></i>&nbsp;&nbsp;
      Module not activated!</p>
    </div>
     : 
     <p style={{fontSize:18,fontWeight:700,padding:20}}>
       <i className="icofont-exclamation-tringle" style={{color:'red',fontSize:20}}></i>&nbsp;&nbsp;
       Module not activated!</p>
  );
};



export default Invoices;